export default "__VITE_ASSET__Fk1cxdaS__"